import { ConfigService } from './../common/services/config.service';
import { HttpInterceptor } from '../common/services/httpInterceptor.service';
import { Injectable } from '@angular/core';
import { CommonConstants } from './../common/utilities/commonConstants';
import { Observable } from 'rxjs';
import { SessionHandlerService } from '../common/services/sessionHandler.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
    providedIn: 'root'
})
export class HomeService {
    constructor(
        private _httpInterceptor: HttpInterceptor,
        private _sessionHandlerService: SessionHandlerService,
        private http: HttpClient
    ) {
    }
    public StartActiviti(data: any): Observable<ActivitiModel.MTResponse<any>> {
        return this._httpInterceptor.Post(
            ConfigService.getInstance().getConfigObject().APIURL.startApplicationActiviti, data);
    }
    public GetSystemAuthToken(requestData: any): Observable<ActivitiModel.MTResponse<any>> {
        const customHeaders = {
            platform: this.getDevicePlatformType()
        };
        return this._httpInterceptor.Post(this.getUrlBasedOnKey('getTokenForUser'),
            requestData, true);
    }
    private getDevicePlatformType(): string {
        const cookieData = this._sessionHandlerService
            .GetSession(CommonConstants.CookieKeys.DeviceDetails);
        if (cookieData && cookieData !== '') {
            const deviceDetails: DeviceDetails = JSON.parse(cookieData);
            return deviceDetails.mobile ? 'mob' : 'desk'; // desk, mob, moba
        } else {
            return 'desk';
        }
    }
    private getUrlBasedOnKey(key: string): string {
        return ConfigService.getInstance().getConfigObject().APIURL[key];
    }

    miniOrangeAccessToken(accessSsoToken, JWToken) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authtoken': JWToken
        });
        const body = {
            accessToken: accessSsoToken
        };
        return this.http.post(this.getUrlBasedOnKey('postMoauthLogin'), body, {headers})
    }
}
